"use client";

import posthog from "posthog-js";

export type MarketingEvent =
  | { name: "marketing_page_viewed"; props: { path: string } }
  | {
      name: "marketing_cta_clicked";
      props: {
        cta_id: string;
        destination: string;
        identifier_type?: "email" | "phone";
      };
    }
  | { name: "marketing_pricing_tier_clicked"; props: { tier_id: string } };

type EventName = MarketingEvent["name"];
type EventProps<N extends EventName> = Extract<
  MarketingEvent,
  { name: N }
>["props"];

export function trackMarketingEvent<N extends EventName>(
  name: N,
  props: EventProps<N>,
): void {
  posthog.capture(name, props);
}
